import MicroFrontend from '../Microfrontend'

export function LocalClearanceOverview() {
    const localClearanceHost = process.env.REACT_APP_CLEARANCE_OVERVIEW_HOST
    return (
            <MicroFrontend
                host={localClearanceHost}
                microFrontendUiName="LocalClearanceOverview"/>
    )
}